import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";

import { post } from "../axios-post";

export const apiCallReassignKhattabaAll = async ({
  oldAssignedAdminId,
  newAssignedAdminId,
  leavingArabicMessage,
  leavingEnglishMessage,
  leavingFrenshMessage,
  leavingTurkishMessage,
  leavingIndonesianMessage
}: {
  oldAssignedAdminId: number;
  newAssignedAdminId: number;
  leavingArabicMessage: string;
  leavingEnglishMessage: string;
  leavingFrenshMessage: string;
  leavingTurkishMessage: string;
  leavingIndonesianMessage: string;
}): Promise<{
  data: {};
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    data: {};
  }>(`khattabat/reassignKhattabaAll`, {
    oldAssignedAdminId,
    newAssignedAdminId,
    leavingArabicMessage,
    leavingEnglishMessage,
    leavingFrenshMessage,
    leavingTurkishMessage,
    leavingIndonesianMessage
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};

export const apiCallReassignKhattabaOne = async ({
  oldAssignedAdminId,
  newAssignedAdminId,
  userIdToReassign,
  leavingArabicMessage,
  leavingEnglishMessage,
  leavingFrenshMessage,
  leavingTurkishMessage,
  leavingIndonesianMessage
}: {
  oldAssignedAdminId: number;
  newAssignedAdminId: number;
  userIdToReassign: number;
  leavingArabicMessage: string;
  leavingEnglishMessage: string;
  leavingFrenshMessage: string;
  leavingTurkishMessage: string;
  leavingIndonesianMessage: string;
}): Promise<{
  data: {};
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    data: {};
  }>(`khattabat/reassignKhattabaOne`, {
    oldAssignedAdminId,
    newAssignedAdminId,
    userIdToReassign,
    leavingArabicMessage,
    leavingEnglishMessage,
    leavingFrenshMessage,
    leavingTurkishMessage,
    leavingIndonesianMessage
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
